export default [
  {
    path: '/noticias',
    name: 'noticias',
    component: () => import(/* webpackChunkName: "noticias" */ '../../views/noticias/Noticias')
  },
  {
    path: '/administracao-noticias',
    name: 'noticias-administracao',
    component: () => import(/* webpackChunkName: "noticias-administracao" */ '../../views/noticias/NoticiasAdministracao')
  },
  {
    path: '/noticias/detalhes/:id',
    name: 'detalhes-noticias',
    component: () => import(/* webpackChunkName: "detalhes-noticias" */ '../../views/noticias/Detalhes')
  },
  {
    path: '/noticias/cadastro/:id',
    name: 'edicao-noticias',
    component: () => import(/* webpackChunkName: "edicao-noticias" */ '../../views/noticias/Cadastro')
  },
  {
    path: '/noticias/cadastro',
    name: 'cadastro-noticias',
    component: () => import(/* webpackChunkName: "cadastro-noticias" */ '../../views/noticias/Cadastro')
  }
]
